module.exports = {
  language: {
    login: '登入', // 登陆按钮
    userName: '用户名', // 用户名
    foodCategory: '如果您是素食者，請在此打“√”', // 食物类别
    veryPoor: '極差', // 極差
    poor: '差', // 差
    good: '可', // 可
    excellent: '優', // 優
    outstanding: '極優', // 極優
    tripTitle: '行程及服務評價', // 行程主标题
    serviceTitle: '綜合評價', // 整体服务主标题
    save: '保存', // 保存按钮
    submit: '送出', // 提交按钮
    home: '回首頁', // 返回首页按钮
    saveSuccessTitle: '保存成功', // 保存成功页面 标题
    saveSuccessContent: '您的評價資料已保存', // 保存成功页面 内容
    close: '關閉', // 送出提示  关闭按钮
    submitTitle: '送出提示', // 送出提示  标题
    submitContent: '評價資料送出後即無法再次編輯，若您仍有尚未完成的評價請按“保存”存檔，以便後續可繼續填寫。', // 送出提示 内容
    confirmSubmit: '確認送出', // 送出提示  确认按钮
    submitSuccessTitle: '送出成功！', // 送出成功页面 标题
    serviceTripTitle: '整體綜合評價', // 综合评价页面 标题
    submitSuccessContent: `<h2>您已成功提交滿意調查表<br>非常感謝您的參與!</h2><p>更多精彩旅程等待您來體驗<br><a href="https://www.signettours.com">www.signettours.com</a></p>`, // 送出成功页面 内容
    dayRateTitle: '評價', // 行程页面 标题
    dayInputTitle: '建議:', // 行程页面 input 标题
    dayInputTips: '非必填', // 行程页面 input 提示文字
    previousDay: '上一天', // 上一天
    nextDay: '下一天', // 下一天
    nextPage: '下一頁', // 下一頁
    previousPage: '上一頁', // 上一頁
    loginTips: '《滿意調查問卷》', // 登陆提示
    SurveySubmittedLogo: '~@/assets/logo-tw.png"', // 已经提交过问卷LOGO
    SurveySubmittedContent: '您已提交過問卷，謝謝您的參與~' // 已经提交过问卷内容
  }
}
